import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';

import style from './print-format-selector.module.less';

const messages = defineMessages({
  selectPrintFormat: {
    description: 'printModal.selectTemplate',
    defaultMessage: 'Select Template',
    id: '7gS1Y1',
  },
});

export const PrintFormatSelector = ({ availableFormats, onFormatSelected, selectedFormat, isDisabled = false }) => {
  const togglerTitle = selectedFormat ? selectedFormat.name : <FormattedMessage {...messages.selectPrintFormat} />;
  return (
    <div className={style['format-selection']} data-testid='print-format-selector'>
      <DropdownMenu
        disabled={isDisabled}
        dropdownMenuShouldHaveWidthOfButton
        onChange={onFormatSelected}
        value={selectedFormat ? selectedFormat.packingSlipId : undefined}
        variant='form'
      >
        <DropdownMenuToggler testId='print-format-selector-dropdown-toggler'>{togglerTitle}</DropdownMenuToggler>
        {availableFormats.map((format) => (
          <DropdownMenuItem
            key={format.packingSlipId}
            onClick={() => onFormatSelected(format)}
            testId='print-format-selector-dropdown-item'
          >
            {format.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

PrintFormatSelector.propTypes = {
  availableFormats: PropTypes.array.isRequired,
  selectedFormat: PropTypes.shape({
    packingSlipId: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  onFormatSelected: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};
